import englishSvg from '../assets/languages/en.svg'
import spanishSvg from '../assets/languages/es.svg'
import portugueseSvg from '../assets/languages/pt.svg'
import arabicSvg from '../assets/languages/ar.svg'
import chineseSvg from '../assets/languages/zh.svg'
import japaneseSvg from '../assets/languages/ja.svg'
import frenchSvg from '../assets/languages/fr.svg'
import turkishSvg from '../assets/languages/tr.svg'
import polishSvg from '../assets/languages/pl.svg'
import italianSvg from '../assets/languages/it.svg'
// import germanSvg from '../assets/languages/de.svg'
import russianSvg from '../assets/languages/ru.svg'
import dutchSvg from '../assets/languages/nl.svg'
import hebrewSvg from '../assets/languages/he.svg'
import catalaSvg from '../assets/languages/ca.svg'
// import indonesianSvg from '../assets/languages/id.svg'
import nexusLogo from '../assets/nexus.png'
import playbaseLogo from '../assets/playbase.png'

export const apiTimeout = 20000 // 20 seg
export const headerHeight = 90 // px
export const bgImgRatio = 1200 / 1260 // width/height
export const apiBaseUrl = {
  production: 'https://api.metrica-sports.com/v2/api/',
  development: 'https://api-dev.metrica-sports.com/api/',
  local: 'http://localhost:8082/'
}
export const getPlayAppUrl = {
  production: 'https://getplay.metrica-sports.com',
  development: 'http://getplay-dev.metrica-sports.com',
  local: 'http://localhost:3019'
}
export const downloadsAppUrl = {
  production: 'https://downloads.metrica-sports.com/from-trial',
  development: 'http://downloads-dev.metrica-sports.com/from-trial',
  local: 'http://localhost:3020/from-trial'
}
export const resetPasswordUrl = {
  production: 'https://cloud.metrica-sports.com/forgot-password/',
  development: 'http://cloud-dev.metrica-sports.com/forgot-password/',
  local: 'http://localhost:3018/forgot-password/'
}

export const Languages = [
  { value: 'en', label: 'English', icon: englishSvg },
  { value: 'es', label: 'Español', icon: spanishSvg },
  { value: 'pt', label: 'Português', icon: portugueseSvg },
  { value: 'ar', label: 'عربي', icon: arabicSvg },
  { value: 'zh', label: '中文 (简体)', icon: chineseSvg },
  { value: 'ja', label: '日本', icon: japaneseSvg },
  { value: 'fr', label: 'Français', icon: frenchSvg },
  { value: 'tr', label: 'Türkçe', icon: turkishSvg },
  { value: 'pl', label: 'Polski', icon: polishSvg },
  { value: 'it', label: 'Italiano', icon: italianSvg },
  // { value: 'de', label: 'Deutsch', icon: germanSvg },
  { value: 'ru', label: 'Русский', icon: russianSvg },
  { value: 'nl', label: 'Nederlands', icon: dutchSvg },
  { value: 'he', label: 'עִברִית', icon: hebrewSvg },
  { value: 'ca', label: 'Català', icon: catalaSvg }
  // { value: 'id', label: 'Bahasa Indonesia', icon: indonesianSvg }
]

export const Jobs = [
  'videoAnalyst',
  'headCoach',
  'assistantCoach',
  'goalkeeperCoach',
  'dataAnalyst',
  'performance',
  'scout',
  'sportsDirector',
  'academyDirector',
  'player',
  'formerPlayer',
  'doctor',
  'student',
  'journalist',
  'other'
]

export const Sports = [
  'americanFootball',
  'baseball',
  'basketball',
  'fieldHockey',
  'football',
  'futsal',
  'gaelicFootball',
  'handball',
  'iceHockey',
  'lacrosse',
  'netball',
  'padel',
  'rugby',
  'tennis',
  'volleyball',
  'other'
]

// NOTE: rgba(22, 178, 106, 1) is the same var(--metrica-green)
// but we can't use css variables here.
export const theme = {
  palette: {
    common: {
      black: '#000',
      white: '#fff',
      grey: '#929292',
      blue: '#2196f3',
      blue2: '#8fcaf9',
      green: 'rgba(22, 178, 106, 1)'
    },
    background: {
      paper: '#eef5f4',
      default: 'rgba(250, 250, 250, 1)',
      greenTRGradient:
        'radial-gradient(100% 90.04% at 100% 0%, rgba(0, 0, 0, 0.45) 0%, rgba(22, 178, 106, 0.11) 100%);'
    },
    primary: {
      light: 'rgba(22, 178, 106, 1)',
      main: 'rgba(22, 178, 106, 1)',
      dark: 'rgba(22, 178, 106, 1)',
      contrastText: '#fff'
    },
    secondary: {
      light: '#0094FF',
      main: '#0094FF',
      dark: '#fff',
      contrastText: '#fff'
    },
    error: {
      light: 'rgba(230, 110, 126, 1)',
      main: 'rgba(208, 86, 101, 1)',
      dark: 'rgba(150, 52, 62, 1)',
      contrastText: '#fff'
    },
    text: {
      primary: '#ffffff',
      secondary: '#929292',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: '#182535'
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: [
      '"Open Sans"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'sans-serif'
    ].join(',')
  }
}

export const companyWebsiteUrl = 'https://metrica-sports.com'

// Per-product branding & theming (/nexus, /playbase). App is the application code
// understood by the API (metrica-play-3 = Nexus, metrica-play = PlayBase).
export const Products = {
  nexus: {
    id: 'nexus',
    app: 'metrica-play-3',
    displayName: 'Metrica Nexus',
    logo: nexusLogo,
    primaryMain: 'rgba(63, 127, 214, 1)',
    buttonBackground:
      'linear-gradient(90deg, rgba(63, 127, 214, 1) 0%, rgba(43, 196, 138, 1) 100%)',
    buttonColor: '#ffffff',
    gradient:
      'radial-gradient(100% 90.04% at 100% 0%, rgba(0, 0, 0, 0.45) 0%, rgba(63, 127, 214, 0.11) 100%)'
  },
  playbase: {
    id: 'playbase',
    app: 'metrica-play',
    displayName: 'Metrica PlayBase',
    logo: playbaseLogo,
    primaryMain: 'rgba(166, 226, 46, 1)',
    buttonBackground: 'rgba(166, 226, 46, 1)',
    buttonColor: 'rgba(13, 26, 5, 1)',
    gradient:
      'radial-gradient(100% 90.04% at 100% 0%, rgba(0, 0, 0, 0.45) 0%, rgba(166, 226, 46, 0.11) 100%)'
  }
}

// Default product applied to legacy invitation links (/invitation without a product prefix).
export const defaultProduct = Products.nexus

export const emailErrorResponse = 'ValidationError:'
export const userKeyResponse = 'UserKeyError:'
export const passwordPolicyErrorResponse = 'PasswordPolicyError:'
export const fieldLengthErrorResponse = 'FieldLengthError:'

// NOTE: keep in sync with the API (lib/passwordPolicy.js).
export const PasswordPolicy = {
  minLength: 8,
  maxLength: 64,
  // The API hashes passwords with bcrypt, which only uses their first 72 bytes.
  maxBytes: 72
}

// Max length of the text fields (inputs' maxLength). The password's is checked by PasswordPolicy.
// NOTE: keep in sync with the API (lib/userFieldLimits.js).
export const FieldMaxLengths = {
  name: 100,
  lastName: 100,
  email: 255,
  clubCompany: 255,
  phone: 50,
  userKey: 100
}

export const termsAndConditionsUrl = 'https://metrica-sports.com/terms-conditions/'
// eslint-disable-next-line
export const emailRegex =
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

export const AnalyticsEventTypes = {
  USER_CREATED: 'USER_CREATED',
  GO_TO_DOWNLOADS: 'GO_TO_DOWNLOADS'
}

export const AnalyticsEvents = {
  TRIAL_USER_CREATED: 'TRIAL_USER_CREATED'
}
